import styled from 'styled-components';

export const HomePageContainer = styled.div`
    // background-color: whitesmoke;
    width: 100vw;
    height: 100vh; /* Just for demonstration, adjust as needed */
    max-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;

    .home-scroll {
        width: 100%;
        height: auto;

        .text-and-image-box {
            padding: 50px 0 50px 0;
        }
    }
`;